import { mutator } from 'satcheljs';
import MailboxLoadStateEnum from '../store/schema/MailboxLoadStateEnum';
import { setLoadingStateForMailbox } from '../actions/internalActions';
import getMailboxTable from '../selectors/getMailboxTable';

/**
 * Mutator that sets the loading state for mailbox.
 * @param actionMessage
 */
export default mutator(setLoadingStateForMailbox, actionMessage => {
    const loadingState: MailboxLoadStateEnum = actionMessage.loadingState;
    const mailbox = getMailboxTable().get(actionMessage.mailboxId);
    mailbox.loadingState = loadingState;
});
